class CustomSelect extends HTMLElement {
  constructor() {
    super();
    this.value = this.getAttribute('value');
    this.options = this.querySelectorAll('custom-option');
    this.previewContainer = this.querySelector('.custom_select-preview');
    this.container = this.querySelector('.custom_select-option-list');
    this.init();
  }

  init = () => {
    if (!this.previewContainer || !this.container) {
      return;
    }
    document.addEventListener('click', this.onClickOutside);
    document.addEventListener('custom-event:close', this.hideContainer);
    this.previewContainer.addEventListener('click', this.toggleContainerState);
    this.options.forEach((optionEl) =>
      optionEl.addEventListener('click', this.onClickOption),
    );
    if (this.value) {
      this.setCheckOptions(this.value);
    }
  };

  onClickOption = (e) => {
    const el = e.currentTarget;
    if (!el) {
      return;
    }
    this.value = el.value;
    this.setCheckOptions(this.value);
    this.toggleContainerState();
    this.dispatchEvent(
      new Event('change', {
        target: this,
        currentTarget: this,
      }),
    );
  };

  setNewPreviewValue = ({ label }) => {
    this.previewContainer.innerHTML = label;
  };

  setCheckOptions = (value) => {
    if (!this.options?.length || !value) {
      return;
    }
    let labelValue = null;
    this.options.forEach((optionEl) => {
      if (optionEl.value === value) {
        labelValue = optionEl.innerText;
      }
      optionEl.checked = optionEl.value === value;
    });

    if (labelValue) {
      this.setNewPreviewValue({ label: labelValue });
    } else {
      this.setNewPreviewValue({ label: 'Choose an option' });
    }
  };

  get value() {
    if (this._value === null) {
      return [...this.options]?.find((option) => option.checked)?.value;
    }
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.setCheckOptions(val);
  }

  toggleContainerState = () => {
    this.container.classList.toggle('custom_select-active');
  };

  openContainer = () => {
    this.container.classList.add('custom_select-active');
  };

  hideContainer = () => {
    this.container.classList.remove('custom_select-active');
  };

  onClickOutside = (e) => {
    const el = e.target;
    if (el !== this && !this.contains(el)) {
      this.hideContainer();
    }
  };
}

class CustomOption extends HTMLElement {
  constructor() {
    super();
    this.value = this.getAttribute('value');
    this.checked = this.getAttribute('checked');
    this.disabled = this.getAttribute('disabled');
  }

  updateOptionCheckedStatus = () => {
    if (this._checked) {
      this.setAttribute('checked', true);
    } else {
      this.removeAttribute('checked');
    }
  };

  updateOptionDisabledStatus = () => {
    if (this._disabled) {
      this.setAttribute('disabled', true);
    } else {
      this.removeAttribute('disabled');
    }
  };

  get value() {
    return this._value;
  }

  set value(val) {
    this._value = val;
  }

  get checked() {
    return this._checked;
  }

  set checked(newVal) {
    this._checked =
      typeof newVal === 'boolean'
        ? newVal
        : newVal === 'checked' || newVal === 'true';
    this.updateOptionCheckedStatus();
  }

  get disabled() {
    return this._disabled;
  }

  set disabled(newVal) {
    this._disabled =
      typeof newVal === 'boolean'
        ? newVal
        : newVal === 'disabled' || newVal === 'true';
    this.updateOptionDisabledStatus();
  }
}

if (!customElements.get('custom-select')) {
  customElements.define('custom-select', CustomSelect);
}

if (!customElements.get('custom-option')) {
  customElements.define('custom-option', CustomOption);
}
